import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";

export const publishVersionedAgent = {
  name: "publishVersionedAgent" as const,
  input: VersionedAgentSchema.pick({ _id: true }),
  output: VersionedAgentSchema,
};
